
(() => {
  const HANDLE = "bead-name-necklace";
  const NAMES = Array.from(
    { length: 8 },
    (_, index) => `Bead ${index + 1} Name`
  );

  let scheduled = false;

  function updateFields() {
    const picker = document.querySelector(
      `variant-picker[handle="${HANDLE}"]`
    );

    if (!picker) return;

    const container = picker.closest(".product-info");
    if (!container) return;

    const groups = [
      ...picker.querySelectorAll(".variant-picker__option")
    ];

    const beadsGroup = groups.find((group) => {
      const legend = group.querySelector("legend");

      return /number of beads|número de contas/i.test(
        legend?.textContent || ""
      );
    });

    if (!beadsGroup) return;

    const selectedText = beadsGroup.querySelector(
      ".variant-picker__option-info span"
    )?.textContent?.trim();

    const count = Number.parseInt(selectedText, 10);

    if (!Number.isInteger(count) || count < 1 || count > 8) {
      return;
    }

    NAMES.forEach((name, index) => {
      const wrapper = [
        ...container.querySelectorAll(
          "[data-personalization-field]"
        )
      ].find(
        (element) =>
          element.dataset.personalizationField === name
      );

      if (!wrapper) return;

      const input = wrapper.querySelector("input, textarea");
      if (!input) return;

      const visible = index < count;

      wrapper.hidden = !visible;
      wrapper.style.display = visible ? "" : "none";

      input.required = visible;
      input.disabled = !visible;

      if (!visible && input.value !== "") {
        input.value = "";
        input.dispatchEvent(
          new Event("input", { bubbles: true })
        );
      }
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateFields();
    });
  }

  function start() {
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["aria-checked", "checked"]
    });

    document.addEventListener(
      "change",
      scheduleUpdate,
      true
    );

    document.addEventListener(
      "click",
      scheduleUpdate,
      true
    );

    updateFields();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
})();
